import React from "react";
import {
  Card,
  CardContent,
  Box,
  Typography,
  alpha,
  useTheme,
} from "@mui/material";
import { GridViewRounded } from "@mui/icons-material";
import ImageLoader from "../../../../components/ImageLoader/ImageLoader";
import { getSubcategoryImage } from "../../utils/subcategoryData";

/**
 * SubcategoryCard Component
 * Displays a single subcategory card with image/emoji and name
 */
const SubcategoryCard = ({ subcategory, isSelected, onClick }) => {
  const theme = useTheme();
  const emoji = getSubcategoryImage(subcategory.name);
  const isAllCategory = subcategory.id === "all" || subcategory.name === "all";

  return (
    <Card
      elevation={0}
      onClick={onClick}
      sx={{
        cursor: "pointer",
        minWidth: 140,
        maxWidth: 180,
        border: isSelected
          ? `2px solid ${theme.palette.secondary.main}`
          : `1px solid ${alpha(theme.palette.divider, 0.1)}`,
        bgcolor: "background.paper",
        borderRadius: 2,
        transition: "all 0.2s ease",
        "&:hover": {
          borderColor: theme.palette.secondary.main,
          transform: "translateY(-2px)",
          boxShadow: `0 4px 12px ${alpha(theme.palette.secondary.main, 0.12)}`,
        },
      }}
    >
      <CardContent sx={{ p: 1.5, "&:last-child": { pb: 1.5 } }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.5,
          }}
        >
          <Box
            sx={{
              width: 44,
              height: 44,
              borderRadius: 2,
              bgcolor: isSelected
                ? alpha(theme.palette.secondary.main, 0.1)
                : alpha(theme.palette.secondary.main, 0.05),
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
              fontSize: "1.5rem",
              transition: "all 0.2s ease",
              overflow: "hidden",
            }}
          >
            {isAllCategory ? (
              <GridViewRounded
                sx={{
                  fontSize: "1.75rem",
                  color: isSelected
                    ? theme.palette.secondary.main
                    : theme.palette.secondary.light,
                }}
              />
            ) : subcategory.image ? (
              <ImageLoader
                imagePath={subcategory.image}
                width={44}
                height={44}
                alt={subcategory.name}
                borderRadius={2}
              />
            ) : (
              emoji
            )}
          </Box>
          <Typography
            variant="body2"
            sx={{
              fontWeight: isSelected ? 700 : 600,
              textAlign: "left",
              textTransform: "capitalize",
              fontSize: "0.8rem",
              color: isSelected ? theme.palette.secondary.main : "text.primary",
              lineHeight: 1.3,
              flex: 1,
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              wordBreak: "break-word",
            }}
          >
            {subcategory.name}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default SubcategoryCard;
